// extracted by mini-css-extract-plugin
module.exports = {"header":"ActionCategory_header__XHmzE","icon":"ActionCategory_icon__k4Sio"};